export default __webpack_public_path__ + "static/media/1582.59b48365.png";